import React from 'react';
import { Link } from 'react-router-dom';
import { getEvidenceById } from '../lib/evidence';

const brucki = getEvidenceById('brucki-2003');
const medians = brucki.results.educationMedians;

function DeepDive({ to, children }) {
  return (
    <p className="mt-4 text-[0.9375rem]">
      <Link to={to} className=" text-[var(--primary)] underline">
        {children}
      </Link>
    </p>
  );
}

export default function EditorialContent() {
  return (
    <div className="public-article max-w-[800px] mx-auto px-4 py-12 space-y-12"><div className="space-y-12">
      <section id="o-que-e">
        <h2 className="mb-4">O que é o Mini Mental?</h2>
        <div className="max-w-none space-y-4 text-[var(--text)]">
          <p>O Mini Mental é um instrumento breve utilizado para organizar uma avaliação cognitiva inicial. Seu nome completo é Mini Exame do Estado Mental, frequentemente abreviado como MEEM. Internacionalmente, ele é conhecido como Mini-Mental State Examination ou MMSE.</p>
          <p>O instrumento reúne tarefas relacionadas à orientação, registro de informações, atenção, evocação, linguagem e capacidade visuoconstrutiva. O desempenho é convertido em uma pontuação de até 30 pontos.</p>
          <p>Apesar de sua ampla utilização, o Mini Mental é um instrumento de rastreio. Ele não substitui anamnese, avaliação funcional, exame clínico ou investigação complementar.</p>
          <DeepDive to="/quem-pode-aplicar">Quem pode aplicar o Mini Mental e o que o treinamento exige →</DeepDive>
        </div>
      </section>

      <section id="pontuacao">
        <h2 className="mb-4">Como funciona a pontuação?</h2>
        <p className="mb-5">A pontuação total varia de 0 a 30. Em termos gerais, um número maior representa melhor desempenho nas tarefas realizadas. Entretanto, o valor não funciona como uma medida universal de normalidade.</p>
        <div className="overflow-x-auto">
          <table className="data-table">
            <thead><tr><th>Escolaridade</th><th className="text-right">Mediana (Brucki et al., 2003)</th></tr></thead>
            <tbody>
              <tr><td>Sem escolaridade formal</td><td className="text-right">{medians.noFormalEducation}</td></tr>
              <tr><td>1 a 4 anos</td><td className="text-right">{medians.years1To4}</td></tr>
              <tr><td>5 a 8 anos</td><td className="text-right">{String(medians.years5To8).replace('.', ',')}</td></tr>
              <tr><td>9 a 11 anos</td><td className="text-right">{medians.years9To11}</td></tr>
              <tr><td>12 anos ou mais</td><td className="text-right">{medians.years12OrMore}</td></tr>
            </tbody>
          </table>
          <p className="mt-3 text-sm text-[var(--text-muted)]">Estes números são medianas observadas no estudo, e não pontos de corte diagnósticos universais.</p>
        </div>
        <DeepDive to="/escolaridade">Mini Mental por escolaridade: medianas, cortes e o que diferencia os dois →</DeepDive>
        <DeepDive to="/pontos-de-corte">Pontos de corte do Mini Mental: compare as principais referências brasileiras →</DeepDive>
        <DeepDive to="/interpretacao-dos-resultados">Como interpretar um resultado já calculado no contexto clínico →</DeepDive>
      </section>

      <section id="interpretacao">
        <h2 className="mb-4">O Mini Mental diagnostica Alzheimer?</h2>
        <p className="mb-3 font-display text-xl font-semibold text-[var(--primary)]">Não. O Mini Mental não diagnostica Alzheimer isoladamente.</p>
        <p>A doença de Alzheimer é uma das possíveis causas de declínio cognitivo, mas o diagnóstico exige análise clínica ampla, incluindo história clínica, relato de familiares, avaliação funcional e exames complementares.</p>
        <DeepDive to="/diagnostica-alzheimer">O que o MEEM estabelece, o que o diagnóstico exige e as causas reversíveis →</DeepDive>
      </section>

      <section>
        <h2 className="mb-4">Limitações do Mini Mental</h2>
        <dl className="border-t border-[var(--border-strong)]">
          {[
            { t: 'Escolaridade', d: 'Pessoas com menor educação formal tendem a pontuar menos sem que isso signifique doença.' },
            { t: 'Efeito Teto', d: 'Alterações cognitivas leves podem não ser detectadas em pessoas com alta escolaridade.' },
            { t: 'Visão e Audição', d: 'Dificuldades sensoriais podem prejudicar a execução das tarefas, reduzindo o escore artificialmente.' },
            { t: 'Momentâneo', d: 'Condições clínicas e ambientais podem interferir no desempenho e precisam ser consideradas na interpretação.' }
          ].map(item => (
            <div key={item.t} className="grid gap-1 border-b border-[var(--border)] py-3 sm:grid-cols-[11rem_1fr] sm:gap-6">
              <dt className="font-sans text-base font-semibold text-[var(--primary)]">{item.t}</dt>
              <dd className="text-[0.9375rem] text-[var(--text-muted)]">{item.d}</dd>
            </div>
          ))}
        </dl>
        <DeepDive to="/mini-mental-ou-moca">Mini Mental ou MoCA: quando o efeito teto pede outro instrumento →</DeepDive>
      </section>
    </div></div>
  );
}
